var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBubbleSize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 140 140",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 0C31.3 0 0 31.3 0 70s31.3 70 70 70 70-31.3 70-70S108.7 0 70 0zM22.4 79V59.3c0-2.8 1.7-5.7 4.5-5.7h84.6c2.8 0 3.8 2.8 3.8 5.7v19.3h-5V63.3c0-.7-.3-1.3-1-1.3s-1 .6-1 1.3v15.3h-14V68.5c0-.7-.3-1.3-1-1.3s-1 .6-1 1.3v10.1h-13V68.5c0-.7-.8-1.3-1.5-1.3s-1.5.6-1.5 1.3v10.1h-13V68.5c0-.7-.3-1.3-1-1.3s-1 .6-1 1.3v10.1h-13V63.3c0-.7-.8-1.3-1.5-1.3s-1.5.6-1.5 1.3v15.3h-13V68.5c0-.7-.3-1.3-1-1.3s-1 .6-1 1.3v10.1h-6.8c-.6 0-1.1.3-1.1.4zm93 2.6v1c0 2.8-1 4-3.8 4H26.9c-2.8 0-4.5-1.2-4.5-4v-1.2c0 .1.6.3 1.2.3h91.8v-.1z",
    fill: "#FFF",
    opacity: 0.2
  })));
}

export default SvgBubbleSize;